<div class="main-container">
    <app-header></app-header>
    <router-outlet />
</div>
